import Text from "components/common/Text/Text";
import { Col } from "react-grid-system";
import styled from "styled-components";
import theme from "themes/simple-theme";
import media from "utils/styleUtils";

export const Checkbox = styled.div`
  border-radius: ${theme.global.radius};
  color: ${theme.color.primary};
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${theme.color.secondary};
  padding: 1vh;
  box-sizing: border-box;
`;
export const InterestName = styled(Text)`
  padding-top: 0.5rem;
  width: 100%;
  word-break: break-word;
  font-family: ${theme.fontFamily.light};
  text-transform: capitalize;
`;

export const ShrinkingCol = styled(Col)`
  display: flex;
`;



// WEBPACK FOOTER //
// ./src/components/ElementSelector/Common/ElementBlock/ElementBlock.style.tsx